import { render, staticRenderFns } from "./LogsTableItemSkeletonMobile.vue?vue&type=template&id=b6565fc4&scoped=true"
import script from "./LogsTableItemSkeletonMobile.vue?vue&type=script&lang=js"
export * from "./LogsTableItemSkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./LogsTableItemSkeletonMobile.vue?vue&type=style&index=0&id=b6565fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6565fc4",
  null
  
)

export default component.exports